import styled from "styled-components";

const SectionTitleContainer = styled.div`
  width: 100%;
  /* border: 2px solid yellow; */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;

  /* position: relative; */
  overflow: hidden;
`;

export default SectionTitleContainer;
